import React from 'react';
import Footer from './Footer';
import axios from 'axios';
import { object, string, number } from 'yup';

function PlaywrightRegister() {
  let initialState = {
    name: '',
    email: '',
    phone: '',
    courses: '--',
  };

  const [formData, setFormData] = React.useState(initialState);
  const [showAlert, setShowAlert] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  let schema = object().shape({
    name: string().required(),
    email: string().email().required(),
    phone: number().required(),
    courses: string()
      .test('is-valid', 'Please select a course', (value) => value !== '--')
      .required(),
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleReset = () => {
    setFormData(initialState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await schema.validate(formData);
    } catch (error) {
      return alert(error.message);
    }
    setIsLoading(true);
    await axios
      .post('https://appendgooglesheet-rao5lvirzq-uc.a.run.app', formData)
      .then(() => {
        setShowAlert(true);
        handleReset();
        setIsLoading(false);
      });
  };

  return (
    <div style={{ margin: '190px 0px 0px 0px' }}>
      <div className="row align-items-start" id="contactMe">
        <div
          style={{ padding: '0 60px 0 0' }}
          className="col-sm-6"
          id="contactText"
        >
          <h1 className="text-info" style={{ fontSize: '44px' }}>
            Playwright with TypeScript
          </h1>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Course Objectives
          </h2>
          <p style={{ fontSize: '15px' }}>
            The Playwright with TypeScript course is designed to provide
            participants with a comprehensive understanding of test automation
            using Playwright, a powerful open-source automation library for web
            applications. Participants will learn how to write robust and
            maintainable test scripts using TypeScript, a statically typed
            superset of JavaScript. The course covers the fundamentals of
            Playwright, including browser automation, element interaction,
            and test execution. Participants will also explore advanced topics
            such as handling asynchronous operations, working with multiple
            browsers, and integrating Playwright with popular testing frameworks.
          </p>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Who will benefit?
          </h2>
          <p style={{ fontSize: '15px' }}>
            This course is ideal for software testers, quality assurance
            professionals, and developers who want to enhance their skills in
            test automation using Playwright and TypeScript. It is suitable for
            individuals with a basic understanding of web development and
            programming concepts. Whether you are new to test automation or
            looking to expand your existing knowledge, this course will equip
            you with the necessary skills to create efficient and reliable test
            scripts.
          </p>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Prerequisites
          </h2>
          <p style={{ fontSize: '15px' }}>
            Basic knowledge of computers and a willingness to learn programming.
            No prior programming experience required.
          </p>
          <h2 className={'text-auto'} style={{ fontSize: '24px' }}>
            Skills Gained & Benefits
          </h2>
          <ul className={'list-group'}>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Comprehensive understanding of test automation concepts and
              techniques
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Proficiency in Playwright with TypeScript for UI testing
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Hands-on experience in building automated testing solutions
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Knowledge of best practices and strategies in test automation
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              Hands-on experience in integrating test automation with CI/CD
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              3 months access to private github repository with code samples,
              exercises, solutions and course materials
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              3 months access to private one on one mentoring sessions with
              Playwright Typescript experts
            </li>
            <li className={'list-group-item'} style={{ fontSize: '15px' }}>
              24 months access to private Google Chat space for Playwright technical support
            </li>
          </ul>
        </div>
        <div className="col-sm-6">
          {showAlert && (
            <div className="alert alert-success" role="alert">
            Registration Successful, we will contact you soon!
            </div>
          )}
          <form className="mt-4" method="POST" onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={formData.name}
                required
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                required
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="Number" className="form-label">
                Phone Number
              </label>
              <input
                className="form-control"
                id="Number"
                name="phone"
                value={formData.phone}
                required
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor={'courses'} className={'form-label'}>
                Course Start Date & Fee
              </label>
              <select
                className="form-select"
                id="courses"
                name="courses"
                value={formData.courses}
                required
                onChange={handleChange}
              >
                <option value="--" disabled>
                  --
                </option>
                <option value={'Test Automation Mastery Course August 23rd 2025'}>
                  August 30th 2025 - £400
                </option>
                <option
                  value={'Test Automation Mastery Course October 18th 2025'}
                >
                  October 18th 2025 - £400
                </option>
              </select>
            </div>
            <button type="submit" className="btn btn-info" disabled={isLoading}>
              Register
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PlaywrightRegister;
